<template>
    <div>
        <div class="page-banner">
            <h1>{{ pageTitle }}</h1>
        </div>

        <div class="page-content">
            <div class="page-content__inner">
                <div v-if="showInitialUnsubscribeForm" class="unsub" v-html="content"
                     :class="[currentLanguage == 'AR' ? 'rtlText': '']">
                </div>
                <br v-if="showInitialUnsubscribeForm"/>
                <div id="unsubform" v-if="!hideUnsubContent">

                    <form method="POST" @submit.prevent="submitPhoneNumber">
                        <label v-if="showInitialUnsubscribeForm" for="phoneNumber" v-html="$t('unsubscribe.title')"
                               :class="[currentLanguage == 'AR' ? 'rtlText': '']"></label>

                        <input v-if="showInitialUnsubscribeForm"
                            type="tel"
                            id="phoneNumber"
                            name="phone-number"
                            v-model="phoneNumber"
                            class="phone-number-input"
                            :placeholder="this.phoneFormat"
                            :maxlength="this.phoneFormat.length"
                            :style="[this.phoneIsValid ? { color: '#48A73D' } : '']"
                        />
                        <div v-if="showInitialUnsubscribeForm">
                          <span>
                            (Format: {{ this.phoneFormat }})
                          </span>
                        </div>
                        <div v-if="errors.length">
                            <ul>
                                <li v-for="error in errors" :key="error.id">
                                    <span style="color: red"
                                          :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{
                                            error.message
                                        }}</span>
                                </li>
                            </ul>
                        </div>
                        <div v-if="success">
                            <span style="color: green"
                                  :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{
                                    $t("unsubscribe.successMessage")
                                }}</span>
                        </div>
                        <div v-if="verificationPending && !verificationFinished" class="verification-code-field">
                            <label for="verificationCode" class="verification-code-label">{{ $t('unsubscribe.verificationCodeLabel') }}</label>
                            <input id="verificationCode" v-model="verificationCode" class="verification-code-input"
                                   inputmode="numeric" maxlength="6" />
                        </div>
                        <div v-if="showInitialUnsubscribeForm" id="manual-recaptcha-test" style="min-height: 80px;text-align: center;width: fit-content;margin: 20px auto auto;"></div>

                        <div class="form-button">
                            <button v-if="showInitialUnsubscribeForm" type="submit" class="unsubscribe-btn">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20.015"
                                    height="15.325"
                                    viewBox="0 0 20.015 15.325"
                                >
                                    <path
                                        d="M16.262,79.011H12.978a.47.47,0,0,1-.469-.469V76.978a.47.47,0,0,1,.469-.469h3.284a1.25,1.25,0,0,0,1.251-1.251V67.753A1.25,1.25,0,0,0,16.262,66.5H12.978a.47.47,0,0,1-.469-.469V64.469A.47.47,0,0,1,12.978,64h3.284a3.754,3.754,0,0,1,3.753,3.753v7.506A3.754,3.754,0,0,1,16.262,79.011Zm-1.837-7.857L7.857,64.586a.94.94,0,0,0-1.6.665V69H.938A.936.936,0,0,0,0,69.942v3.753a.936.936,0,0,0,.938.938H6.255v3.753a.94.94,0,0,0,1.6.665l6.567-6.567A.946.946,0,0,0,14.425,71.154Z"
                                        transform="translate(0 -64)"
                                    />
                                </svg>
                                <span :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{
                                        $t("unsubscribe.button")
                                    }}</span>
                            </button>
                            <button v-else-if="verificationPending && !verificationFinished" type="button" class="unsubscribe-btn" @click="verifyCode">{{ $t('unsubscribe.verificationCodeButton') }}</button>

                        </div>
                    </form>
                </div>
                <br/>
                <div class="unsub" :class="[currentLanguage == 'AR' ? 'rtlText': '']"
                     v-if="showInitialUnsubscribeForm && !hideUnsubContent && $t('unsubscribe.afterForm') != 'unsubscribe.afterForm'"
                     v-html="$t('unsubscribe.afterForm')">
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import {helpers} from '@/helper/portal_config';
import {RecaptchaV2} from "vue3-recaptcha-v2";

const apiMethod = 'getPortalUnsubscription';

export default {
    name: 'Unsubscription',
    title: `${helpers.portal_name} Unsubscription`,
    data() {
        return {
            pageTitle: this.$i18n.t('unsubscription'),
            content: '',
            phoneNumber: '',
            phoneFormat: '',
            lastEnteredMobile: 'toto',
            robot: false,
            link: '',
            errors: [],
            success: false,
            helpers: helpers,
            currentLanguage: "",
            currentCountry: "",
            recaptchaSiteKey: '6LeaItAaAAAAAFEtCW_enXxRC9Dfv6vIOZHU0iyU',
            recaptchaToken: '',
            verificationPending: false,
            verificationToken: '',
            verificationCode: '',
            verificationFinished: false,
        };
    },
    components: {
        RecaptchaV2
    },
    mounted() {
        // For countries where the unsub form is hidden (e.g. CZ), the reCAPTCHA
        // container is not rendered, so skip reCAPTCHA initialization.
        if (this.hideUnsubContent) {
            return;
        }
        const scriptId = 'recaptcha-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                console.log('reCAPTCHA script loaded');
                window.grecaptcha.ready(() => {
                    console.log('grecaptcha is ready');

                    window.grecaptcha.render('manual-recaptcha-test', {
                        sitekey: this.recaptchaSiteKey,
                        callback: this.onVerify,
                        'expired-callback': this.onExpired,
                        'error-callback': this.onError
                    });
                });
            };
            document.head.appendChild(script);
        } else {
            console.log('Script already present');

            window.grecaptcha.ready(() => {
                window.grecaptcha.render('manual-recaptcha-test', {
                    sitekey: this.recaptchaSiteKey,
                    callback: this.onVerify,
                    'expired-callback': this.onExpired,
                    'error-callback': this.onError
                });
            });
        }
    },
    methods: {
        checkForm() {
            this.errors = [];
            this.success = false;
            if (this.phoneNumber) {
                return true;
            }
            const errorObj = {id: 1, message: this.$i18n.t('unsubscribe.invalidPhone')};
            this.errors.push(errorObj);
            return false;
        },
        onVerify(response) {
            console.log('reCAPTCHA verified:', response);
            this.robot = true;
            this.recaptchaToken = response;
        },

        onExpired() {
            console.log('reCAPTCHA expired');
            this.robot = false;
            this.recaptchaToken = '';
        },
        onError(error) {
            console.error('reCAPTCHA error:', error);
            this.robot = false;
            this.recaptchaToken = '';
        },
        isCaptcha() {
            if (this.robot && this.recaptchaToken) {
                return true;
            }
            const errorObj = {id: 1, message: this.$i18n.t('unsubscribe.captchaError')};
            this.errors.push(errorObj);
            return false;
        },
        setCurrentCountry() {
            const {host} = window.location;
            this.currentCountry = host.split('.')[0].slice(0, 2).toUpperCase();
        },
        setCurrentLanguage() {
            var lang = "";
            const {host} = window.location;
            var country = host.split('.')[0].slice(0, 2).toUpperCase();
            if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
                lang = helpers.countryDefaultLanguage[country].toUpperCase();
            } else {
                lang = country.toUpperCase();
            }
            this.currentLanguage = lang;
        },
        getMessageForErrorCode(errorCode) {
            this.errors = [];
            const langErrorMsg = this.$i18n.t(`error.E${errorCode}`);
            if (langErrorMsg) {
                this.errorMsg = langErrorMsg;
            } else {
                this.errorMsg = this.$i18n.t('error.default');
            }
            const errorObj = {
                id: 222,
                message: this.errorMsg,
            };
            this.errors.push(errorObj);
        },
        setPhoneFormat() {
            this.phoneFormat = helpers.languagePhoneFormat[this.currentCountry] || '';
        },
        submitPhoneNumber() {
            if (this.phoneNumber == this.lastEnteredMobile) {
                return false;
            }
            if (!this.checkForm() || !this.isCaptcha()) return false;
            this.lastEnteredMobile = this.phoneNumber

            axios.post(`${helpers.API_BASE_URL}/store/SendUnsubscribeVerificationCode`, {
                service: helpers.portal_name, country: this.currentCountry, language: this.currentLanguage,
                phone_number: this.phoneNumber, 'g-recaptcha-response': this.recaptchaToken,
            })
                .then((response) => {
                    if (response.data.legacy_unsubscribe) {
                        this.submitLegacyUnsubscribe();
                        return;
                    }

                    if (response.data.treatment == 1) {
                        this.verificationToken = response.data.verification_token;
                        this.verificationPending = true;
                    }
                    this.robot = false;
                    this.recaptchaToken = '';
                    if (window.grecaptcha) {
                        window.grecaptcha.reset();
                    }
                })
                .catch((error) => {
                    this.getMessageForErrorCode(error.response.data.error_code);
                    this.lastEnteredMobile = 'toto';
                    this.robot = false;
                    this.recaptchaToken = '';
                    if (window.grecaptcha) {
                        window.grecaptcha.reset();
                    }
                });
        },
        submitLegacyUnsubscribe() {
            axios.get(`${helpers.API_BASE_URL}/store/UnsubscribePhoneNumber`, {
                params: {
                    service: helpers.portal_name,
                    country: this.currentCountry,
                    language: this.currentLanguage,
                    phone_number: this.phoneNumber,
                    'g-recaptcha-response': this.recaptchaToken,
                },
            }).then((response) => {
                if (response.data.treatment == 1) {
                    this.success = true;
                }
            }).catch((error) => {
                this.getMessageForErrorCode(error.response?.data?.error_code);
            }).finally(() => {
                this.robot = false;
                this.recaptchaToken = '';
                this.lastEnteredMobile = 'toto';
                if (window.grecaptcha) {
                    window.grecaptcha.reset();
                }
            });
        },
        verifyCode() {
            this.errors = [];
            if (!/^\d{6}$/.test(this.verificationCode)) {
                this.errors = [{id: 3, message: this.$t('unsubscribe.verificationCodeInvalid')}];
                return;
            }
            axios.post(`${helpers.API_BASE_URL}/store/VerifyUnsubscribeVerificationCode`, {
                verification_token: this.verificationToken, verification_code: this.verificationCode,
            }).then((response) => {
                this.verificationFinished = true;
                return axios.get(`${helpers.API_BASE_URL}/store/UnsubscribePhoneNumber`, {
                    params: {service: helpers.portal_name, country: this.currentCountry, language: this.currentLanguage,
                        phone_number: this.phoneNumber, verification_token: response.data.verification_token}
                });
            }).then((response) => {
                if (response.data.treatment == 1) {
                    this.success = true;
                    return;
                }
                this.getMessageForErrorCode(response.data.error_code);
            }).catch((error) => {
                if (Number(error.response?.data?.error_code) === 2095) {
                    this.errors = [{id: 3, message: this.$t('unsubscribe.verificationCodeIncorrect')}];
                    return;
                }
                this.verificationFinished = true;
                this.getMessageForErrorCode(error.response?.data?.error_code);
            });
        },
    },
    computed: {
        showInitialUnsubscribeForm() {
            return !this.verificationPending && !this.verificationFinished;
        },
        hideUnsubContent() {
            // For CZ, hide the unsubscribe form (phone input, format hint, captcha,
            // submit button and after-form text) on all portals. The DB content
            // (intro text) stays visible.
            return ['CZ', 'AE'].includes(this.currentCountry);
        },
        phoneIsValid() {
            if (this.currentCountry == 'EE' && this.phoneNumber &&
                (this.phoneNumber.length === this.phoneFormat.length ||
                    this.phoneNumber.length === this.phoneFormat.length - 1)) {
                return true;
            } else if (this.phoneNumber && this.phoneNumber.length === this.phoneFormat.length) {
                return true;
            }
            return false;
        },
    },
    created() {
        this.setCurrentLanguage();
        this.setCurrentCountry();
        this.setPhoneFormat();

        axios
            .get(
                `${helpers.API_BASE_URL}/store/${apiMethod}?portal_name=${
                    helpers.portal_name
                }&country=${this.currentCountry}&language=${this.currentLanguage}`,
            )
            .then((response) => {
                if (response.data.treatment === 1) {
                    const str = response.data.content;
                    const stringData = str.replace(/\\n/g, '<br />');
                    this.content = stringData;
                }
            });
    },
};
</script>

<style scoped>
.verification-code-field {
    margin-top: 1rem;
}

.verification-code-label {
    display: block;
    margin-bottom: 0.5rem;
}

.verification-code-input {
    display: block;
    width: 8rem;
    max-width: 100%;
    letter-spacing: 0.25em;
    text-align: center;
}

.phone-number-input,
.verification-code-input {
    margin-right: auto;
    margin-left: auto;
}
</style>
